<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div id="Events">
        <mobileHeader v-if="isMobile == 'Mobile'" touterNum=2></mobileHeader>
        <Header v-else></Header>
        <backhead :title="titleLabel"></backhead>
        <div class="mainbox" :class="{ Mobileclass: isMobile == 'Mobile' }">
            <iframe src="https://quanjing.artron.net/scene/iWeHChaSxmGkG7i9dHDlnBf2R9dwSLJv/20240708_tlsx/tour.html" width="100%" height="500px" frameborder="0"></iframe>
            <!-- <h1 class="app-title"><a href="https://quanjing.artron.net/scene/iWeHChaSxmGkG7i9dHDlnBf2R9dwSLJv/20240708_tlsx/tour.html">{{ hrefLabel }}</a></h1> -->
        </div>
    </div>
</template>

<script setup>
    import { ref, watch, computed } from 'vue';
    import { getshowList } from "../utils/gerData";
    import { currentLanguage } from "../utils/lang";
    const isMobile = localStorage.getItem('userAgent')

    const arrList = ref([]);

    import { backheadTitles, pageLabels,imageurl } from "../utils/i18nLabels";
    const titleLabel = computed(() => backheadTitles.panorama[currentLanguage.value || 'zh'])
    const hrefLabel = computed(() => pageLabels.panorama.href[currentLanguage.value || 'zh'])

    // 获取列表数据
    function getList() {
        let queryParams = {
            page: 1,
            pageSize: 100,
            pid: 8
        }
        getshowList(queryParams).then(res => {
            const data = res.data
            data.list.map(item => {
                item.image = item.image ? imageurl + item.image : undefined
            })
            arrList.value = data.list;
        });
    }
    getList()

    watch(currentLanguage, () => {
        getList()
    })
</script>

<style scoped>
    #Events{
        overflow: hidden;
    }
    .mainbox{
        overflow: hidden;
        margin-top: 200px;
        text-align: left;
        padding: 60px;
        h1{
            text-align: center;
            margin: 50px auto;
            font-size: 26px;
            text-decoration: underline;
        }
    }

    .Mobileclass{
        margin-top: 160px;
          padding: 10px;
    }
</style>